import { useEffect, useState } from "react";
import { useAuth } from "../fetch/useAuth";

export const LoginForm: React.FC = () => {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [companyLoginId, setCompanyLoginId] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { login } = useAuth();

  useEffect(() => {
    const cachedCompanyLoginId = updateCachedCompanyLoginId();
    if (cachedCompanyLoginId) {
      setCompanyLoginId(cachedCompanyLoginId);
    }
  }, []);

  const updateCachedCompanyLoginId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryStringCompanyLoginId = urlParams.get("company_login_id");
    if (queryStringCompanyLoginId !== null) {
      const companyLoginIdDiv = document.getElementById("company_login_id_div");
      if (companyLoginIdDiv) {
        companyLoginIdDiv.style.display = "none";
      }
      try {
        localStorage.setItem("company_login_id", queryStringCompanyLoginId);
        return queryStringCompanyLoginId;
      } catch (e) {
        console.error(e);
      }
    }

    try {
      const localStorageCompanyLoginId =
        localStorage.getItem("company_login_id");
      if (localStorageCompanyLoginId !== null) {
        const companyLoginIdDiv = document.getElementById(
          "company_login_id_div",
        );
        if (companyLoginIdDiv) {
          companyLoginIdDiv.style.display = "none";
        }
        return localStorageCompanyLoginId;
      }
    } catch (e) {
      console.error(e);
    }

    return null;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      // WORKAROUND: companyLoginId が空文字の場合は "0" にして送信する (20241024)
      // 最終的には、companyLoginIdをサブドメインとしてログインページごと分けたい
      // ロジポケ側では運用影響大きいので、貨物PF側で運用テストしてから逆輸入の予定
      await login({
        loginId,
        password,
        companyLoginId: companyLoginId || "0",
        rememberMe,
      });
      window.location.href = "/";
    } catch (error) {
      console.error("Login failed:", error);
      setErrorMessage("ログインできませんでした。再度やり直してください。");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "50px" }}>
      <div
        style={{
          backgroundColor: "white",
          border: "white",
          borderRadius: "10px",
          padding: "50px 0",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        <form onSubmit={onSubmit}>
          <div
            style={{
              margin: "0 auto 20px",
              width: "100%",
              maxWidth: "360px",
              padding: "0 20px",
              boxSizing: "border-box",
            }}
          >
            <label
              htmlFor="login_id"
              style={{
                display: "block",
                color: "#6B7075",
                fontWeight: 400,
                fontSize: "1rem",
                lineHeight: 1.5,
              }}
            >
              ログインID
            </label>
            <input
              type="text"
              id="login_id"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              autoComplete="login_id"
              style={{
                width: "100%",
                height: "2rem",
                boxSizing: "border-box",
                border: "1px solid #CDCFD1",
                borderRadius: "6px",
                padding: "0 0.5rem",
                maxWidth: "100%",
              }}
            />
          </div>

          <div
            style={{
              margin: "0 auto 20px",
              width: "100%",
              maxWidth: "360px",
              padding: "0 20px",
              boxSizing: "border-box",
            }}
          >
            <label
              htmlFor="password"
              style={{
                display: "block",
                color: "#6B7075",
                fontWeight: 400,
                fontSize: "1rem",
                lineHeight: 1.5,
              }}
            >
              パスワード
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              style={{
                width: "100%",
                boxSizing: "border-box",
                height: "2rem",
                border: "1px solid #CDCFD1",
                borderRadius: "6px",
                padding: "0 0.5rem",
                maxWidth: "100%",
              }}
            />
          </div>

          <div
            id="company_login_id_div"
            style={{
              margin: "0 auto 20px",
              width: "100%",
              maxWidth: "360px",
              padding: "0 20px",
              boxSizing: "border-box",
            }}
          >
            <label
              htmlFor="company_login_id"
              style={{
                color: "#6B7075",
                fontWeight: 400,
                fontSize: "1rem",
                lineHeight: 1.5,
              }}
            >
              会社ID
            </label>
            <label
              htmlFor="company_login_id_not_required"
              style={{ color: "#6B7075" }}
            >
              (未設定の場合は入力不要)
            </label>
            <input
              type="text"
              id="company_login_id"
              value={companyLoginId}
              onChange={(e) => setCompanyLoginId(e.target.value)}
              style={{
                width: "100%",
                height: "2rem",
                boxSizing: "border-box",
                border: "1px solid #CDCFD1",
                borderRadius: "6px",
                padding: "0 0.5rem",
                maxWidth: "100%",
              }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ marginBottom: "20px" }}>
              <input
                type="checkbox"
                id="remember_me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ border: "1px solid #CDCFD1" }}
              />
              <label
                htmlFor="remember_me"
                style={{
                  color: "#6B7075",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: 1.5,
                }}
              >
                ログイン状態を保持する
              </label>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <button
              type="submit"
              style={{
                fontWeight: 500,
                fontSize: "0.875rem",
                lineHeight: 1.75,
                letterSpacing: "0.02857em",
                textTransform: "uppercase",
                minWidth: "64px",
                padding: "6px 16px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                backgroundColor: "#009999",
                color: "#ffffff",
              }}
            >
              ログインする
            </button>
          </div>

          {errorMessage && (
            <div
              style={{ color: "red", marginTop: "50px", textAlign: "center" }}
            >
              {errorMessage}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
